import Styles from './ConfigureReviewAutomationModal.module.scss'
import { ReviewType, ReviewPrivacy, ReviewerRole } from 'components/ReviewsWizard/types'
import { RadioButtonOption } from 'components/RadioButton/Types'
import { reviewerRoleDefault } from 'components/ReviewsWizard/fetchReviewTypeConfig'

export const roleProps = (reviewType: ReviewType) => {
  return {
    reviewersLabelClassNames: reviewType === ReviewType.FEEDBACK ? Styles.label : Styles.secondaryLabel,
    approversLabelClassNames: reviewType === ReviewType.APPROVAL ? Styles.label : Styles.secondaryLabel,
    viewersLabelClassNames: reviewType === ReviewType.READ_RECEIPTS ? Styles.label : Styles.secondaryLabel,
    reviewersLabel:
      reviewType === ReviewType.FEEDBACK ? 'Reviewers to be included on the request every time' : undefined,
    approversLabel:
      reviewType === ReviewType.APPROVAL ? 'Approvers to be included on the request every time' : undefined,
    viewersLabel:
      reviewType === ReviewType.READ_RECEIPTS ? 'Viewers to be included on the request every time' : undefined,
  }
}

export const REQUESTED_TYPE: Record<ReviewType, string> = {
  [ReviewType.FEEDBACK]: 'review',
  [ReviewType.SUGGESTIONS]: 'review',
  [ReviewType.APPROVAL]: 'approval',
  [ReviewType.READ_RECEIPTS]: 'read receipt',
} as const

export enum DueDateDays {
  ONE = '1',
  THREE = '3',
  FIVE = '5',
  SEVEN = '7',
  FOURTEEN = '14',
  INDEFINITELY = '0',
  CUSTOM = 'CUSTOM',
}

export const DEFAULT_DURATION = DueDateDays.THREE

export const rolesMenuItems = (reviewerRoles: ReviewerRole[]) => {
  return [
    {
      key: 'reviewers',
      text: 'Add Reviewers',
      textValue: 'AddReviewers',
      enabled: !reviewerRoles.includes(ReviewerRole.REVIEWER),
    },
    {
      key: 'approvers',
      text: 'Add Approvers',
      textValue: 'AddApprovers',
      enabled: !reviewerRoles.includes(ReviewerRole.APPROVER),
    },
    {
      key: 'viewers',
      text: 'Add Viewers',
      textValue: 'AddViewers',
      enabled: !reviewerRoles.includes(ReviewerRole.VIEWER),
    },
  ]
}

export const radioOptions: RadioButtonOption<ReviewPrivacy>[] = [
  {
    key: ReviewPrivacy.PRIVATE,
    description: 'Create a layer for private comments and edits you can merge down later',
  },
  {
    key: ReviewPrivacy.PUBLIC,
    description: 'Keep on the main layer for every editor to see',
  },
]

export const reviewerRolesFromUsers = (
  reviewType: ReviewType,
  reviewers?: number[],
  approvers?: number[],
  viewers?: number[],
) => {
  const reviewerRole = reviewerRoleDefault(reviewType)
  const roles = new Set(reviewerRole ? [reviewerRole] : [])

  if (reviewers && reviewers.length > 0) {
    roles.add(ReviewerRole.REVIEWER)
  }
  if (approvers && approvers.length > 0) {
    roles.add(ReviewerRole.APPROVER)
  }
  if (viewers && viewers.length > 0) {
    roles.add(ReviewerRole.VIEWER)
  }
  return Array.from(roles)
}
